export const maskEmailAddress = (email) => {
  let response = email;
  if (email && email !== ""){
    const emailUnique = email.split("@")[0];
    const emailUniqueEnd = email.split("@")[1];
    if (emailUnique.length > 3){
      response = emailUnique.substring(0,3);
      for (let i = 0; i < emailUnique.length - 3; i++){
        response += "*";
      }
    }
    else{
      response = emailUnique.substring(0,1);
      for (let i = 0; i < emailUnique.length - 1; i++){
        response += "*";
      }
    }

    if (emailUniqueEnd !== undefined && emailUniqueEnd !== null && emailUniqueEnd !== ""){
      response += "@" + emailUniqueEnd;
    }
  }
  return response;
};


export const maskPhoneNumber = (phoneNumber) => {
  let response = phoneNumber;
  if (phoneNumber && phoneNumber !== ""){
    const phoneNumberEnd = phoneNumber.substring(phoneNumber.length - 2);
    if (phoneNumber.length >= 13){
      response = phoneNumber.substring(0,7);
      for (let i = 0; i < phoneNumber.length - 9; i++){
        response += "*";
      }
    }
    else if (phoneNumber.length >= 9 && phoneNumber.length <= 12){
      response = phoneNumber.substring(0,4);
      for (let i = 0; i < phoneNumber.length - 6; i++){
        response += "*";
      }
    }
    else{
      response = phoneNumber.substring(0,2);
      for (let i = 0; i < phoneNumber.length - 4; i++){
        response += "*";
      }
    }
    response += phoneNumberEnd;
  }
  return response;
};


export default maskEmailAddress;
